import React, { useState, useRef } from 'react';
import { Play, Pause, Music } from 'lucide-react';
import { MondrianButton } from './ui/MondrianButton';
import { MondrianPanel } from './ui/MondrianPanel';
import { AudioVisualizer } from './AudioVisualizer';
import { MondrianGrid } from './MondrianGrid';
export function BoogieWoogieSonifier() {
  const [isPlaying, setIsPlaying] = useState(false);
  // In a real app, we would use Web Audio API here
  // For this demo, we simulate the state
  const togglePlay = () => {
    setIsPlaying(!isPlaying);
  };
  return <div className="space-y-8" data-id="element-25">
      <div className="text-center space-y-2" data-id="element-26">
        <h2 className="text-2xl font-bold uppercase" data-id="element-27">工具二：布吉伍吉奏鸣器</h2>
        <p className="text-gray-600" data-id="element-28">聆听画作的韵律，感受视觉与听觉的通感</p>
      </div>

      <div className="grid md:grid-cols-2 gap-8" data-id="element-29">
        {/* Visual Source */}
        <div className="space-y-4" data-id="element-30">
          <h3 className="font-bold text-lg border-b-4 border-mondrian-black inline-block" data-id="element-31">
            视觉源 (Visual Source)
          </h3>
          <div className="aspect-square border-4 border-mondrian-black relative" data-id="element-32">
            <MondrianGrid density="high" data-id="element-33" />
            {isPlaying && <div className="absolute inset-0 bg-mondrian-yellow/10 animate-pulse pointer-events-none" data-id="element-34" />}
          </div>
        </div>

        {/* Audio Output */}
        <div className="space-y-4 flex flex-col" data-id="element-35">
          <h3 className="font-bold text-lg border-b-4 border-mondrian-black inline-block" data-id="element-36">
            听觉映射 (Audio Mapping)
          </h3>

          <MondrianPanel className="flex-1 flex flex-col gap-6" borderWidth={4} data-id="element-37">
            {/* Visualizer */}
            <div className="flex-1 min-h-[200px] border-4 border-mondrian-black" data-id="element-38">
              <AudioVisualizer isPlaying={isPlaying} data-id="element-39" />
            </div>

            {/* Controls */}
            <div className="flex justify-center gap-4" data-id="element-40">
              <MondrianButton variant={isPlaying ? 'red' : 'blue'} onClick={togglePlay} className="w-full flex justify-center items-center gap-2" data-id="element-41">
                {isPlaying ? <>
                    <Pause data-id="element-42" /> 暂停 (PAUSE)
                  </> : <>
                    <Play data-id="element-43" /> 播放 (PLAY)
                  </>}
              </MondrianButton>
            </div>

            {/* Legend */}
            <div className="grid grid-cols-2 gap-2 text-xs font-bold" data-id="element-44">
              <div className="flex items-center gap-2" data-id="element-45">
                <div className="w-4 h-4 bg-mondrian-yellow border-2 border-mondrian-black" data-id="element-46"></div>
                <span data-id="element-47">旋律 (Melody)</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-48">
                <div className="w-4 h-4 bg-mondrian-red border-2 border-mondrian-black" data-id="element-49"></div>
                <span data-id="element-50">重音 (Drums)</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-51">
                <div className="w-4 h-4 bg-mondrian-blue border-2 border-mondrian-black" data-id="element-52"></div>
                <span data-id="element-53">贝斯 (Bass)</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-54">
                <div className="w-4 h-4 bg-mondrian-gray border-2 border-mondrian-black" data-id="element-55"></div>
                <span data-id="element-56">停顿 (Rest)</span>
              </div>
            </div>
          </MondrianPanel>
        </div>
      </div>
    </div>;
}